"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setLoggingLevel = exports.setGlobalDataLayer = exports.registerEventManagerWithConfig = exports.registerEventManager = exports.getEventManager = void 0;
var Helper = __importStar(require("firefly-utilities-helper-ts"));
var firefly_utilities_ts_1 = require("firefly-utilities-ts");
var event_manager_1 = __importDefault(require("./event-manager"));
var storage_keys_1 = __importDefault(require("./constants/storage-keys"));
var data_layer_interceptor_1 = __importDefault(require("./interceptors/data-layer-interceptor"));
var global_data_layer_interceptor_1 = __importDefault(require("./interceptors/global-data-layer-interceptor"));
var event_interceptor_1 = __importDefault(require("./interceptors/event-interceptor"));
function getEventManager(eventConfig) {
    var eventManagerKey = eventConfig.eventManagerKey, persistMethod = eventConfig.persistMethod;
    var eventConfiguration = firefly_utilities_ts_1.PersistenceManager.get(eventManagerKey + storage_keys_1.default.EVENT_CONFIGURATION, persistMethod);
    return createEventManager(eventConfiguration);
}
exports.getEventManager = getEventManager;
function registerEventManager(eventManagerKey, apiKey, persistMethod, retries, schemaId, url) {
    var eventConfiguration = { apiKey: apiKey, eventManagerKey: eventManagerKey, persistMethod: persistMethod, retries: retries, schemaId: schemaId, url: url };
    return registerEventManagerWithConfig(eventConfiguration);
}
exports.registerEventManager = registerEventManager;
function registerEventManagerWithConfig(eventConfiguration) {
    var eventManagerKey = eventConfiguration.eventManagerKey, persistMethod = eventConfiguration.persistMethod;
    persistEventManagerKey(eventManagerKey, persistMethod);
    resetPageLoadData(persistMethod);
    firefly_utilities_ts_1.PersistenceManager.set(eventManagerKey + storage_keys_1.default.EVENT_CONFIGURATION, eventConfiguration, persistMethod);
    return createEventManager(eventConfiguration);
}
exports.registerEventManagerWithConfig = registerEventManagerWithConfig;
function setGlobalDataLayer(json, persistMethod) {
    var globalDataLayerInterceptor = new global_data_layer_interceptor_1.default();
    var decoratedJson = globalDataLayerInterceptor.apply(json, persistMethod);
    var eventManagerKeys = firefly_utilities_ts_1.PersistenceManager.get(storage_keys_1.default.REGISTERED_EVENT_MANAGERS, persistMethod);
    if (Helper.isArray(eventManagerKeys)) {
        eventManagerKeys.forEach(function (eventManagerKey) {
            var eventManager = getEventManager({ eventManagerKey: eventManagerKey, persistMethod: persistMethod });
            eventManager.setDataLayer(decoratedJson);
        });
    }
}
exports.setGlobalDataLayer = setGlobalDataLayer;
function setLoggingLevel(logLevel) {
    firefly_utilities_ts_1.Logger.initialize(logLevel);
}
exports.setLoggingLevel = setLoggingLevel;
function createEventManager(eventConfiguration) {
    return new event_manager_1.default(eventConfiguration, new data_layer_interceptor_1.default(), new event_interceptor_1.default());
}
function resetPageLoadData(persistMethod) {
    firefly_utilities_ts_1.FFPersistenceManager.setSessionValue('viewId', '', persistMethod);
}
function persistEventManagerKey(eventManagerKey, persistMethod) {
    var eventManagerKeys = firefly_utilities_ts_1.PersistenceManager.get(storage_keys_1.default.REGISTERED_EVENT_MANAGERS, persistMethod);
    var eventManagerSet = new Set(eventManagerKeys);
    eventManagerSet.add(eventManagerKey);
    firefly_utilities_ts_1.PersistenceManager.set(storage_keys_1.default.REGISTERED_EVENT_MANAGERS, Array.from(eventManagerSet), persistMethod);
}
